import { Company } from "../company/Company";

import { IActivityStreams, INonAutoPolicy, IPolicyDocument } from "../../resources/interfaces";
import { User } from "../User";
import { Country } from "../../types";
import { IPolicyMetaData, IPolicyUpdate } from "../policy/IPolicy";
import { Applicant } from "../applicant/Applicant";
import { Insurer } from "../insurer/Insurer";

export default class NonAutoPolicy {
  active: boolean;
  activeAndValid: boolean;
  activityStreams: IActivityStreams[];
  broker: Company;
  commissionRateType: string;
  commissionRateValue: number;
  country: Country;
  coverageDetails: string;
  createdOn: string;
  currency: string;
  currencyRate: number;
  applicant: Applicant;
  expired: boolean;
  expiryDate: string;
  grossPremium: number;
  id: number;
  inceptionDate: string;
  insurer?: Insurer;
  metaData: IPolicyMetaData;
  netPremium: number;
  paidPremium: number;
  policyCategory: string;
  policyNumber: string;
  policyTerm: string;
  policyType: string;
  reviewStage: string;
  staff: User;
  sumInsured: number;
  updatedOn: string;
  documents: IPolicyDocument[] | undefined;
  payments: PremiumSummary[] | undefined;
  insurerPolicyNumber?: string;
  policyUpdates: IPolicyUpdate[];
  premiumPaidToInsurer: boolean
  renewable: boolean
  renewed: boolean
  renewedOn: string
  renewedPolicyNumber: string
  settlementReceivedByBroker: boolean

  constructor(Imodel: INonAutoPolicy) {
    this.id = Imodel.id;
    this.active = Imodel.active;
    this.activeAndValid = Imodel.activeAndValid;
    this.activityStreams = Imodel.activityStreams;
    this.broker = Imodel.broker;
    this.commissionRateType = Imodel.commissionRateType;
    this.commissionRateValue = Imodel.commissionRateValue;
    this.country = Imodel.country;
    this.coverageDetails = Imodel.coverageDetails;
    this.createdOn = Imodel.createdOn;
    this.currency = Imodel.currency;
    this.currencyRate = Imodel.currencyRate;
    this.applicant = new Applicant({
      ...Imodel.customer,
      address: Imodel.customer?.address,
      occupation: Imodel.customer?.occupation,
      phoneNumber: Imodel.customer?.phone,
      phoneVerified: Imodel.customer?.phoneVerified,
      otherPhone: Imodel.customer?.otherPhone,
      otherPhoneVerified: Imodel.customer?.otherPhoneVerified,
      customerId: Imodel.customer?.id,
      email: Imodel.customer?.email,
      emailVerified: Imodel.customer?.emailVerified,
      gender: Imodel.customer?.gender,
      firstName: Imodel.customer?.firstName,
      lastName: Imodel.customer?.lastName,
      hasDisease: undefined,
      diseaseOrComplications: undefined,
      dateOfBirth: Imodel.customer?.dateOfBirth,
      idType: Imodel.customer?.idType,
      idNumber: Imodel.customer?.idNumber,
      idVerified: Imodel.customer?.idVerified,
      idExpiryDate: Imodel.customer?.idExpiry,
      employerName: Imodel.customer?.employerName,
      employerAddress: Imodel.customer?.employerAddress,
      employerPhoneNumber: Imodel.customer?.employerPhone,
      monthlyIncome: Imodel.customer?.monthlyIncomeBand,
      socialMedia: Imodel.customer.socialPlatform,
      rideSharePeriod: undefined,
      liability: undefined,
      liabilityDebt: undefined,
      liabilityDetails: undefined,
      liabilityModeOfPayment: '',
      kycAnalysis: Imodel.customer?.kycAnalysis,
      customerDocuments: Imodel.customer?.customerDocuments
    });
    this.expired = Imodel.expired;
    this.expiryDate = Imodel.expiryDate;
    this.grossPremium = Imodel.grossPremium;
    this.inceptionDate = Imodel.inceptionDate;
    this.insurer = Imodel.insurer ? new Insurer(Imodel.insurer) : undefined;
    this.metaData = Imodel.metaData;
    this.netPremium = Imodel.netPremium;
    this.paidPremium = Imodel.paidPremium;
    this.policyCategory = Imodel.policyCategory;
    this.policyNumber = Imodel.policyNumber;
    this.policyTerm = Imodel.policyTerm;
    this.policyType = Imodel.policyType;
    this.reviewStage = Imodel.reviewStage;
    this.staff = Imodel.staff;
    this.sumInsured = Imodel.sumInsured;
    this.updatedOn = Imodel.updatedOn;
    this.documents = Imodel.documents;
    this.payments = Imodel.payments;
    this.insurerPolicyNumber = Imodel.insurerPolicyNumber;
    this.policyUpdates = Imodel.policyUpdates;
    this.premiumPaidToInsurer = Imodel.premiumPaidToInsurer
    this.renewable = Imodel.renewable
    this.renewed = Imodel.renewed
    this.renewedOn = Imodel.renewedOn
    this.renewedPolicyNumber = Imodel.renewedPolicyNumber
    this.reviewStage = Imodel.reviewStage
    this.settlementReceivedByBroker = Imodel.settlementReceivedByBroker

  }
}

export interface ProductType {
  key: string;
  code: string;
  title: string;
  description: string;
}

export interface PremiumSummary {
  id: number;
  applicationNumber: string;
  reference: string;
  ourReference: string;
  accountName: string | null;
  accountNumber: string | null;
  bankName: string | null;
  channel: string;
  amount: number;
  currency: string;
  incrementAmount: number;
  preAmount: number;
  planType: 'FULL_AMOUNT' | string; // use union if more plan types exist
  productType: ProductType;
  category: string;
  code: string;
  phone: string;
  paymentStatus: 'SUCCESS' | 'PENDING' | 'FAILED' | string;
  paymentLink: string | null;
  evidenceUrl: string | null;
  narration: string | null;
  processor: string;
  createdOn: string; // ISO Date string
  updatedOn: string; // ISO Date string
  dateOfPayment: string; // ISO Date string
  dueDate: string; // ISO Date string (YYYY-MM-DD)
  qboLogged: boolean;
}
